import Link from "next/link";

import Button from "ui/Button/Button";

import { CONTACT_PHONE_NUMBER } from "constants/variables";

const CallButton = () => (
  <Link href={`tel:${CONTACT_PHONE_NUMBER}`} legacyBehavior passHref>
    <Button orange fluid>
      Позвонить
    </Button>
  </Link>
);

export default CallButton;
